import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useCurrentSimDataId } from '../../../hooks/SimViewer/useCurrentSimDataId';

const NewTabButton = (): ReactNode => {
  const { t } = useTranslation();
  const { currentSimDataId } = useCurrentSimDataId();
  const { search } = useLocation();

  return (
    <Popover
      content={t('openMapInNewTab')}
      placement="bottomLeft"
      trigger="hover"
    >
      <StyledButton
        type="text"
        href={`/sim-viewer/${currentSimDataId}${search}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon
          icon={faArrowUpRightFromSquare}
          style={{ fontSize: '14px' }}
        />
        {t('newTab')}
      </StyledButton>
    </Popover>
  );
};

const StyledButton = styled(Button)`
  && {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    padding: 0 8px;
    line-height: 1;
  }
`;

export { NewTabButton };
